import { IRootState } from "../../rootReducer";

export function getModalType(state: IRootState) {
  return state.modal.modalType;
}

export function getModalProps(state: IRootState) {
  return state.modal.modalProps;
}
